import {GridContainerCompactType} from '@models/pages/grid-container-compact-type';
import {GridContainerTransitionType} from '@models/pages/grid-container-transition-type';

export class GridContainerSettings {
  columns: number = 12;
  rowHeight: number = 150;
  autoScroll: boolean = false;
  disableDrag: boolean = true;
  disableResize: boolean = true;
  disableRemove: boolean = true;
  autoResize: boolean = true;
  preventCollision: boolean = false;
  columnRanges = {
    singleColumn: {min: 0, max: 1200, size: 2},
    defaultColumn: {min: 1200, max: -1, size: 12}
  };

  compactTypes: GridContainerCompactType[] = [
    {
      value: 'vertical',
      label: 'Vertical'
    }, {
      value: 'horizontal',
      label: 'Horizontal'
    }, {
      value: null,
      label: 'Unspecified'
    }
  ];

  transitions: GridContainerTransitionType[] = [
    {
      label: 'ease',
      value: 'transform 500ms ease, width 500ms ease, height 500ms ease'
    },
    {
      label: 'ease-out',
      value: 'transform 500ms ease-out, width 500ms ease-out, height 500ms ease-out'
    },
    {
      label: 'linear',
      value: 'transform 500ms linear, width 500ms linear, height 500ms linear'
    },
    {
      label: 'overflowing',
      value: 'transform 500ms cubic-bezier(.28,.49,.79,1.35), width 500ms cubic-bezier(.28,.49,.79,1.35), height 500ms cubic-bezier(.28,.49,.79,1.35)'
    },
    {
      label: 'fast',
      value: 'transform 200ms ease, width 200ms linear, height 200ms linear'
    },
    {
      label: 'slow-motion',
      value: 'transform 1000ms linear, width 1000ms linear, height 1000ms linear'
    },
    {
      label: 'transform-only',
      value: 'transform 500ms ease'
    },
  ];


}
